import { Box, Flex, Text } from "@chakra-ui/react";
import UsersDarkIcon from "assets/svg/users-dark-icon";
import UsersCard from "components/card/UsersCard";
import { ROUTES } from "constants/routes";

interface UsersOverviewProps {
  loading: boolean;
  data: IDashboardSummary | null | any;
}

const UsersOverview = ({ loading, data }: UsersOverviewProps) => {
  return (
    <Box display="flex" flexDirection="column" gap={4}>
      <Flex gap={3} alignItems="center">
        <UsersDarkIcon />
        <Text color="#000" fontSize={24} fontWeight={700} lineHeight={"24px"}>
          Users
        </Text>
      </Flex>
      <Box display={`flex`} flexWrap={`wrap`} gap={`2rem`}>
        <UsersCard
          text="All Businesses"
          totalValue={data?.totalBusinesses || 0}
          isLoading={loading}
          viewUsersType={ROUTES.BUSINESSES.path}
        />
        <UsersCard
          text="Approved Businesses"
          totalValue={data?.approvedBusinesses || 0}
          isLoading={loading}
          viewUsersType={`${ROUTES.BUSINESSES.path}?status=approved`}
        />
        <UsersCard
          text="Pending reviews"
          totalValue={data?.pendingReviews || 0}
          isLoading={loading}
          viewUsersType={`${ROUTES.BUSINESSES.path}?status=pending`}
        />
        <UsersCard
          text="Rejected"
          totalValue={data?.rejectedBusinesses || 0}
          isLoading={loading}
          viewUsersType={`${ROUTES.BUSINESSES.path}?status=rejected`}
        />
      </Box>
    </Box>
  );
};

export default UsersOverview;
